import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Variables } from '../variables';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'treatmentreminder',
    templateUrl: './treatmentreminder.component.html',
    styleUrls: ['./treatmentreminder.component.css']
})

export class TreatmentReminderComponent {

    public environment: string;
    public errorResult: boolean;
    public showAppStartButton: boolean;
    public treatmentReminder: TreatmentReminder;

    constructor(public http: HttpClient, public variables: Variables, public router: Router, public sanitizer: DomSanitizer) {

        this.environment = variables.appSettings["Environment"];

        this.getReminder();

        (async () => {
            this.showAppStartButton = false;
            //The app start button logic is not needed anymore
            //await this.delay(4000);
            //this.showAppStartButton = true;
        })();
    }

    public delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public getSessionID() {
        var authSessionStr = localStorage.getItem('authSession');
        if (authSessionStr && authSessionStr != '') {
            try {
                var authSession = JSON.parse(authSessionStr);
                if (Date.now() < authSession.ExpireTime) {
                    return authSession.SessionID;
                }
            }
            catch (error) {
                localStorage.setItem('authSession', '');
            }
        }

        return null;
    }

    public getReminder() {
        var scope = this;
        var sessionID = this.getSessionID();

        if (!sessionID) {
            this.router.navigate([''], { queryParams: { l: this.variables.language, t: this.variables.token } });
            return;
        }
        if (this.variables.language && this.variables.token && this.variables.language != "" && this.variables.token != "") {
            scope.http.get<TreatmentReminder>(scope.variables.getAPIBaseURL() + "treatmentreminder/" +
                this.variables.language + '/' + this.variables.token + '/' + sessionID,
                { headers: new HttpHeaders({ timeout: '20000' }) }).subscribe(result => {
                    this.treatmentReminder = result;
                    localStorage.setItem('authSession', '');
                }, (error) => {
                    if (error.status == 404) {
                        this.treatmentReminder = {
                            treatmentEvents:
                                [
                                    {
                                        eventTitle: "",
                                        eventText: error.error
                                    }
                                ]
                        }
                    } else {
                        this.variables.loginError = true;
                        this.router.navigate([''], { queryParams: { l: this.variables.language, t: this.variables.token } });
                    }

                    localStorage.setItem('authSession', '');
                });
        }
    }
}

class TreatmentReminder {
    activityDescription?: string;
    treatmentCategories?: Treatment[];
    treatmentEvents?: TreatmentEvent[];
}

class Treatment {
    drugTypeName: string;
    drugTypeImgIconURL: string;
    drugName: string;
    drugImgURLs: string[];
    treatmentType: number;
    treatmentInfo: string;
    treatmentStep: string;
    treatmentAmount: number;
}

class TreatmentEvent {
    eventTitle: string;
    eventText: string;
}


// WEBPACK FOOTER //
// ./src/app/treatmentreminder/treatmentreminder.component.ts